import { globals } from "@/core/globals";
import { graphqlClient } from "../../../client";
import mutationDocument from "./updateSavedCreditCardMutation.graphql";
import type {
  GetCustomerPaymentInstrumentsRequestResultType,
  InputUpdatePaymentType,
  Mutations,
  MutationsUpdatePaymentArgs,
} from "@/core/api/graphql/types";

export async function updateSavedCreditCard(
  payload: InputUpdatePaymentType,
): Promise<GetCustomerPaymentInstrumentsRequestResultType> {
  const { storeId, userId, currencyCode } = globals;
  payload.cardDetails.storeId = storeId;
  payload.cardDetails.userId = userId;
  payload.cardDetails.currencyCode = currencyCode;
  const { data } = await graphqlClient.mutate<Required<Pick<Mutations, "updatePayment">>, MutationsUpdatePaymentArgs>({
    mutation: mutationDocument,
    variables: {
      command: {
        ...payload,
      },
    },
  });

  return data!.updatePayment;
}
